






























































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, userPrefPageSize, enumData } from '@/decorators';
import SetWarn from './setWarn/index.vue';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import { Moment } from 'moment';
import regexp from '@/regexp';

@Component({
  components: {
    SetWarn,
    BulkSearchModal,
  },
})
export default class InventoryAgePage extends Vue {
  protected updateWarnValueLoading: boolean = false;
  /**
   * 批量查询的字段
   */
  protected codeField: string = 'product_sku_list';
  /**
   * 列表数据
   */
  protected dataList: TypeInventoryAge.List = [];
  /**
   * 表格列
   */
  protected columns: TypeBase.TableColumn[] = [];
  /**
   * 名称key（商品中文名、商品英文名）
   */
  protected docType: string = 'product_title';
  /**
   * 名称值
   */
  protected docNameValue: string = '';
  /**
   * 加载状态
   */
  protected loadingStatus: boolean = false;
  /**
   * 列表勾选
   */
  protected rowSelection: TypeBase.RowSelection = {};
  /**
   * 仓库列表
   */
  protected warehouseList: TypeCommon.AllWarehouseListItem[] = [];
  /**
   * 搜索项
   */
  protected searchData: TypeInventoryAge.SearchData = this.initSearchData();
  /**
   * 搜索条件缓存
   */
  protected searchParam: TypeInventoryAge.SearchData = this.initSearchData();
  /**
   * 页码总数
   */
  protected total: number = 0;
  /**
   * 选中的sku列表
   */
  protected selectedIdList: number[] = [];
  protected selectedList: TypeInventoryAge.List = [];
  /**
   * 批量查询的内容
   */
  protected docValue: string = '';
  /**
   *  时间范围
   */
  protected datetimeDefaultValue: Moment[] = this.$util.getDefaultTimeCondition();
  /** 日期类型 */
  @enumData('Inventory/InventoryAgeListDateTypeEnum')
  private inventoryAgeListDateTypeEnum: TypeBase.EnumListItem[] = [];
  private get isDisabledFuzzyCode() {
    return !!(this.docValue.length && this.docValue.trim().split(',').length > 1);
  }
  /**
   * 监听时间范围变化
   */
  @Watch('datetimeDefaultValue', { immediate: true })
  protected onDatetimeDefaultValueChange(arr: Moment[]): void {
    if (arr.length) {
      this.searchData.date_start = this.$util.formatDateTime(arr[0]);
      this.searchData.date_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.date_start = '';
      this.searchData.date_end = '';
    }
  }
  /**
   * 初始化搜索条件
   */
  @userPrefPageSize('inventoryAgeList')
  protected initSearchData(): TypeInventoryAge.SearchData {
    return {
      is_fuzzy_code: this.$enum.common.Enabled.NO,
      product_sku_list: [],
      product_barcode_list: [],
      product_sku_like: '',
      product_barcode_like: '',
      product_title: '',
      product_title_en: '',
      warning_age_type: undefined,
      age_from: undefined,
      age_to: undefined,
      quantity_from: undefined,
      quantity_to: undefined,
      warehouse_code: undefined,
      date_start: undefined,
      date_end: undefined,
      iba_id_list: undefined,
      date_type: this.$enum.warehouse.InventoryAgeListDateTypeEnum.FIFO_TIME,
      page_index: 1,
      page_size: 20,
    };
  }
  /**
   * 获取库存列表
   */
  @loading('loadingStatus')
  protected async queryInventoryAgeList(params: TypeInventoryAge.SearchData): Promise<void> {
    const searchData = this.$util.deepCopy(params);
    searchData[this.docType] = this.docNameValue;
    const { data } = await this.$api.warehouse.queryInventoryAgeList<TypeBase.ListResult<TypeInventoryAge.List>>(searchData);
    const { list, total } = data;
    this.dataList = this.$util.createTableRowKey(list);
    this.searchParam = this.$util.deepCopy(searchData);
    this.total = total;
  }
  /**
   * 仓库列表
   */
  protected async queryWarehouseList(): Promise<void> {
    const { data = [] } = await this.$api.common.queryAllWarehouseList();
    this.warehouseList = data;
  }
  /**
   * 导出列表
   */
  protected async export(params: TypeInventoryAge.SearchData): Promise<void> {
    const res = await this.$api.warehouse.exportInventoryAgeList<TypeBase.ExcelDataResult>(params);
    if (res.code === 0) {
      this.$util.exportExcel(res.data);
    }
  }
  /**
   * 更新库龄
   */
  @loading('updateWarnValueLoading')
  protected async updateWarnAge(params: TypeInventoryAge.SetAgeWarnParam): Promise<boolean> {
    const res = await this.$api.warehouse.updateWarnAge(params);
    if (res.code === 0) {
      this.$message.success(this.t('设置成功'));
      this.getList();
      return true;
    } else {
      return false;
    }
  }
  /**
   * 获取列表
   */
  protected getList(): void {
    this.rowSelection.selectedRowKeys = this.selectedIdList = [];
    const value = this.docValue.trim();
    const valueList = value ? value.split(',') : [];
    const params = this.$util.deepCopy(this.searchData);
    if (this.codeField === 'product_barcode_list') {
      params.product_barcode_list = [];
      params.product_barcode_like = '';
      if (this.searchData.is_fuzzy_code) {
        params.product_barcode_like = value;
      } else {
        params.product_barcode_list = valueList;
      }
    } else {
      params.product_sku_list = [];
      params.product_sku_like = '';
      if (this.searchData.is_fuzzy_code) {
        params.product_sku_like = value;
      } else {
        params.product_sku_list = valueList;
      }
    }
    this.queryInventoryAgeList(params);
  }
  /**
   * 重置字段值
   */
  protected resetFieldValue(): void {
    this.searchData.product_sku_list = [];
    this.codeField = 'product_sku_list';
    this.docValue = '';
    this.docType = 'product_title';
    this.docNameValue = '';
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.searchData = this.initSearchData();
  }
  /**
   * 双击批量查询
   */
  protected handleDblClick(): void {
    if (this.codeField === 'product_sku_list' || this.codeField === 'product_barcode_list') {
      const bulkSearchRef = this.$refs.bulkSearchModal as BulkSearchModal;
      bulkSearchRef.modalVisible = true;
      bulkSearchRef.bulkListStr = this.docValue;
    }
  }
  /**
   * 重置页面数据
   */
  protected initPage(): void {
    this.searchData.page_index = 1;
    this.selectedIdList = [];
  }
  /**
   * 库龄格式化为整数
   */
  protected formatter(num: number): string {
    const res = String(num).match(/([0-9]{0,4})/);
    if (res && res[1]) {
      return res[1];
    } else {
      return '';
    }
  }
  protected handleCodeChange(): void {
    if (this.docValue.length && this.docValue.split(',').length > 1) {
      this.searchData.is_fuzzy_code = this.$enum.common.Enabled.NO;
    }
  }
  /**
 * @description:  切换查询模式
 * @return {*}
 */
  protected handleFuzzyChange(e: any) {
    const checked = !!e.target.checked;
    this.searchData.is_fuzzy_code = !!checked ? this.$enum.common.Enabled.YES : this.$enum.common.Enabled.NO;
    console.log(this.searchData.is_fuzzy_code, '321321321');
  }
  /**
   * 切换页码
   */
  protected handlePageChange(val: number): void {
    this.initPage();
    this.searchData.page_index = val;
    this.getList();
  }
  /**
   * 搜索按钮
   */
  protected handleSearch(): void {
    this.initPage();
    this.getList();
  }
  /**
   * 清空
   */
  protected handleReset(): void {
    this.resetFieldValue();
    this.$nextTick(() => {
      this.getList();
    });
  }
  /**
   * 导出全部
   */
  protected async handleExportAll(): Promise<void> {
    const params = this.$util.deepCopy(this.searchParam);
    delete params.page_index;
    delete params.page_size;
    this.export(params);
  }
  /**
   * 导出已选
   */
  protected async handleExportSelected(): Promise<void> {
    if (!this.selectedIdList.length) {
      this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }
    const params = {
      iba_id_list: this.selectedIdList,
      date_start: this.searchParam.date_start,
      date_end: this.searchParam.date_end,
    };
    this.export(params);
  }
  /**
   * 批量搜索
   */
  protected handleBulkFeedback(bulkKeywords: string): void {
    this.docValue = bulkKeywords;
  }
  /**
   * 批量设置预警
   */
  protected handleSetInventoryBluk(): void {
    if (!this.selectedIdList.length) {
      this.$message.warning(this.t('请选择设置项'));
      return;
    }
    this.selectedList = this.dataList.filter((item: TypeInventoryAge.ListItem) => {
      return this.selectedIdList.indexOf(item.iba_id) > -1;
    });
    const setInventoryWarnRef = this.$refs.setInventoryWarnRef as SetWarn;
    setInventoryWarnRef.visible = true;
  }
  /**
   * 单个更新
   */
  protected async handleUpdateWarn(record: TypeInventoryAge.ListItem): Promise<void> {
    const res: boolean = await this.updateWarnAge({
      list: [
        {
          iba_fifo_time: record.iba_fifo_time,
          iba_warning_age: record._iba_warning_age,
          warehouse_code: record.warehouse_code,
          product_barcode: record.product_barcode,
        },
      ],
    });
    if (res) {
      record.iba_warning_age = record._iba_warning_age;
      record._visible = false;
    }
  }
  /**
   * 展示设置预警库龄窗口
   */
  protected handleShowWarningAgeBox(record: TypeInventoryAge.ListItem): void {
    this.$set(record, '_visible', true);
    this.$set(record, '_iba_warning_age', record.iba_warning_age);
  }
  /**
   * 设置成功
   */
  protected handleSuccess(): void {
    this.getList();
  }
  protected handleSubmitSuccess(): void {
    this.getList();
  }
  protected created(): void {
    this.columns = [
      {
        title: this.t('商品编码'),
        disabled: true,
        dataIndex: 'product_sku',
        name: 'product_sku',
        scopedSlots: {
          customRender: 'product_sku',
        },
      },
      {
        title: this.t('谷仓商品条码'),
        disabled: true,
        dataIndex: 'product_barcode',
        name: 'product_barcode',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('中文名称'),
        checked: true,
        name: 'product_title',
        width: 250,
        scopedSlots: {
          customRender: 'product_title',
        },
      },
      {
        title: this.t('英文名称'),
        checked: true,
        name: 'product_title_en',
        width: 250,
        scopedSlots: {
          customRender: 'product_title_en',
        },
      },
      {
        title: this.t('仓库（区域）'),
        dataIndex: 'warehouse_code',
        disabled: true,
        name: 'warehouse_code',
        scopedSlots: {
          customRender: 'warehouse_code',
        },
      },
      {
        title: this.t('上架时间'),
        name: 'iba_fifo_time',
        dataIndex: 'iba_fifo_time',
        disabled: true,
      },
      {
        title: this.t('过期时间'),
        name: 'expiration_date',
        dataIndex: 'expiration_date',
        filterEmpty: true,
        checked: false,
      },
      {
        title: this.t('在库库存'),
        name: 'iba_quantity',
        align: 'right',
        dataIndex: 'iba_quantity',
        disabled: true,
      },
      {
        title: this.t('库龄（天）'),
        name: 'warehouse_age',
        align: 'right',
        filterEmpty: true,
        scopedSlots: {
          customRender: 'warehouse_age',
        },
        disabled: true,
      },
      {
        title: this.t('预警库龄'),
        name: 'iba_warning_age',
        width: 150,
        fixed: 'right',
        align: 'right',
        scopedSlots: {
          customRender: 'iba_warning_age',
        },
        showColumnSetting: true,
      },
    ];
    this.rowSelection = {
      selectedRowKeys: this.selectedIdList,
      onChange: (selectedRowKeys: number[]) => {
        this.rowSelection.selectedRowKeys = this.selectedIdList = selectedRowKeys;
      },
    };
    this.queryWarehouseList();
    this.$nextTick(() => {
      this.getList();
    });
  }
}
